import react, { useEffect, useRef } from "react";
import { authenticateAdminUser } from "./utils";
import { usePopup } from "./PopupContext";


const BogglerAdmin = () => {

    const hasLoggedIn = useRef(false)
    const [email, setEmail] = react.useState("");
    const [password, setPassword] = react.useState("");
    const pop = usePopup()

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    }

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    }

    const authenticate = () => {
        const authenticationData = authenticateAdminUser();
        authenticationData.then(data => {
            if(data && data.isLoggedIn) {
                if(data.isLoggedIn) {
                    window.location.href = "/applicants"; // Redirect to admin dashboard
                }
            }
        });
    }
    useEffect(() => {
        if (hasLoggedIn.current) return
        hasLoggedIn.current = true
        authenticate()
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        
        fetch(`${process.env.REACT_APP_API_URL}/admin/login`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email, password }),
        }   )
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                // Handle successful login
                const { token, token_expiry } = data;
                window.localStorage.setItem('adminToken', token);
                window.localStorage.setItem('adminTokenExpiry', token_expiry);
                authenticate()
            } else {
                // Handle login error
                console.error("Admin login failed");
                pop("Login failed. Please check your credentials and try again.");
            }
        })
        .catch(error => {
            console.error("Error occurred during admin login:", error);
        });
    }

    return (
        <div style={{ textAlign: "center", marginTop: "50px" }}>
            <img
                onClick={() => window.open("/", "_self")}
                src="https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/boggler-logo-clear.webp"
                alt="Boggler Logo"
                className="boggler-logo"
                loading="lazy"
                style={{ borderRadius: 8, width: "80%", maxWidth: "400px" }}
            />
            <h2>Boggler Admin Page</h2>
            <form className="form login" onSubmit={handleSubmit}>
                <div className="form-group">
                    <input onChange={handleEmailChange} className="lg" type="email" name="email" placeholder="Enter admin email"/>
                    <input onChange={handlePasswordChange} className="lg" type="password" name="password" placeholder="Enter admin password" />
                </div>
                <div className="form-actions">
                    <button type="submit" className="wide boggler btn">Login</button>
                </div>
            </form>
        </div>
    );
}

export default BogglerAdmin;